import {
	Directive,
	Input
} from '@angular/core';

/**
 * Creates a local template object variable
 *
 * @example
 * <div
 * 	[appVar]="{isHovered: false}"
 * 	#data="var"
 * 	(mouseenter)="data.isHovered = true"
 * 	(mouseleave)="data.isHovered = false"
 * >
 * 	<span>isHovered {{ data.isHovered }}</span>
 * </div>
 */
@Directive( {
	selector: '[appVar]',
	exportAs: 'var'
} )
export class VarDirective {
	[ key: string ]: any;

	private timeout: number;

	@Input( 'appVar' ) set assign( value: object ) {
		if ( value ) {
			if ( this.timeout ) {
				clearTimeout( this.timeout );
			}

			this.timeout = setTimeout( () => {
				clearTimeout( this.timeout );
				Object.assign( this, value );
			}, 0 );
		}
	}
}
